import axios from 'axios';
import apiClient from "./ApiClient";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export const callLoginApi = (params) => {
    return apiClient.post(baseUrl + '/user/auth/login', params)
};

export const callLogoutApi = (params) => {
    return apiClient.post(baseUrl + '/user/auth/logout', params);
}

export const callReissueApi = (params) => {
    return axios.post(
        baseUrl + '/user/auth/reissue',
        params,
        {
            headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${params.refreshToken}`},
            withCredentials: true,
        }
    );
};

export const callKakaoLogin = (params) => {
    return apiClient.post(baseUrl + '/user/auth/kakaoLogin', params)
};

/* 리프레시 토큰 검증 */
export const callGetExpiredRefreshToken = (params) => {
    return axios.post(
        baseUrl + '/user/auth/getExpiredRefreshToken',
        params,
        {
            headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${params.refreshToken}`},
            withCredentials: true,
        }
    );
};

export const callSelectMemberInfo = (params) => {
    return apiClient.get(baseUrl + '/user/auth/selectMemberInfo', params)
};